<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <!-- <v-row> -->

      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.go(-1)"
          v-if="user && user.IDStB"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br /><br />
        <div
          class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text"
        >
          {{ title }}
        </div>

        <div v-if="user.alumno_mora" style="width: 100%">
          <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
            <v-alert prominent type="warning">
              Para solicitar la baja primero debe abonar su deuda
            </v-alert>
          </v-col>
        </div>

        <div v-else-if="user.borrado == '1'" style="width: 100%">
          <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
            <v-alert prominent type="error" >
              La acción no es posible de realizar, Usted se encuentra dado de baja
            </v-alert>
          </v-col>
        </div>

        <div v-else>
          <!-- <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
            <v-alert prominent type="info">
              Para reservar el turno haz click en el horario disponible
            </v-alert>
          </v-col> -->

          <v-row align="center" v-if="!user || !user.IDStB">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <label>Tipo de documento</label>
              <v-select
                v-model="tipo"
                :items="tipos"
                item-text="text"
                item-value="value"
                label="Selecciona el tipo  de documento"
                persistent-hint
                return-object
                single-line
                v-on:change="loadData"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <label>Número de documento</label>
              <v-text-field
                v-model="documento"
                label="Escribe el número de documento"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <!--
            <v-row align="center">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <label>Sede del trámite</label>
              <v-select
                v-model="sede"
                :items="sedes"
                item-text="text"
                item-value="value"
                label="Selecciona la sede"
                persistent-hint
                return-object
                single-line
                v-on:change="loadData"
              ></v-select>
            </v-col>
          </v-row>
          -->
          <v-row align="center">
            <v-col
              cols="12"
              xs="12"
              sm="12"
              md="12"
              lg="12"
              xl="12"
              v-if="sede.value != ''"
            >
              <FullCalendar
                class="demo-app-calendar"
                :options="calendarOptions"
                ref="calendar"
              >
                <template v-slot:eventContent="arg">
                  <b>{{ arg.timeText }}</b>
                  <i>{{ arg.event.title }}</i>
                </template>
              </FullCalendar>
            </v-col>
          </v-row>
        </div>
      </v-col>

      <template>
        <v-row justify="center">
          <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
              <v-card-title>
                <span class="headline">Reservar turno</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <!--
                       <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
                        <v-alert
                          prominent
                          type="info"
                        >
                         Tenga en cuenta que sólo es para retiro o entrega de documentación
                        </v-alert>
                      </v-col>
                      -->
                    <v-col cols="12">
                      <v-textarea
                        name="input-7-1"
                        v-model="texto"
                        label="Por favor indique el motivo del turno"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">
                  Cancelar
                </v-btn>
                <v-btn color="blue darken-1" text @click="apartar">
                  OK
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>

      <!-- </v-row> -->
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import Route from "../../config/RouteApi";
import esLocale from "@fullcalendar/core/locales/es";
import moment from "moment";

moment.locale("es");

export default {
  name: "MateriaCodigoClaseVideo",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
    FullCalendar,
  },

  data: function() {
    return {
      title: "Horario",
      sede: { text: "", value: "" },
      sedes: [],
      tipo: { text: "DNI", value: 1 },
      documento: "",
      tipos: [
        { text: "DNI", value: 1 },
        { text: "PASAPORTE", value: 2 },
      ],
      editable: true,
      dialog: false,
      texto: "",
      turno_id: "",
      calendarOptions: {
        weekends: "true",
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
        initialView: "timeGridDay",
        headerToolbar: {
          left: "dayGridMonth,timeGridWeek,timeGridDay",
          center: "title",
          right: "prev,next",
        },

        locale: esLocale,
        eventClick: this.handleEventClick,
        events: "",
      },
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  mounted() {
    this.$API
      .get({
        url: "sedes",
        data: {},
      })
      .then((res) => {
        this.sedes = res;
        this.sede.value = this.sedes[this.sedes.length - 1].value;
        this.loadData();
      })
      .catch((err) => {
        console.log(err);
      });
  },

  methods: {
    handleEventClick(clickInfo) {
      let datos = clickInfo.event.extendedProps;
      
      if(datos.link !== ''){
        window.open(datos.link, '_blank');
      }
      
      console.log(datos);
    },

    async loadData() {
      this.calendarOptions.events = Route + `horario/${this.user.IDStB}`;
    },
    async apartar() {
      //this.dialog = false;
      if (this.texto.trim() == "") {
        alert("Debe colocar un motivo para el turno");
        return;
      }

      let dataSend = {
        text: this.texto,
        turno_id: this.turno_id,
        documento: this.documento,
        tipoDocumento: this.tipo.value,
        alumno_id: this.user.IDStB,
      };

      let url = "turno-presencial/inscribirTurno";

      await this.$API
        .post({
          url: url,
          data: dataSend,
        })
        .then(() => {
          this.texto = "";
          this.turno_id = 0;
          this.dialog = false;

          let calendarApi = this.$refs.calendar.getApi();
          calendarApi.refetchEvents();
        });
    },
  },
};
</script>
